import { viewTypes } from './view-types';
import { ISSUE_FILTER_PROPERTIES, PAGE_PARAMS, SORTING_PARAMS } from './issue-query-params';
import featureFlags, { FEATURE_FLAGS } from '../utils/featureFlags';

const sharedPreloadedFilterQueryParamsState = {
  [PAGE_PARAMS.OFFSET]: 0,
  [ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER]: [],
  [ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER]: [],
  [ISSUE_FILTER_PROPERTIES.CREATED_AT_START_FILTER]: '',
  [ISSUE_FILTER_PROPERTIES.CREATED_AT_END_FILTER]: '',
  [ISSUE_FILTER_PROPERTIES.DUE_DATE_START_FILTER]: '',
  [ISSUE_FILTER_PROPERTIES.DUE_DATE_END_FILTER]: '',
};

// We want to set this object once per issue type and view as it is used when resetting filters in the UI (see `Filter.jsx`)
export const preloadedFilterQueryParamsState = {
  [viewTypes.DOCUMENT]: {
    ...sharedPreloadedFilterQueryParamsState,
    [ISSUE_FILTER_PROPERTIES.INCLUDE_HIDDEN_FILTER]: false,
    [ISSUE_FILTER_PROPERTIES.STATUS_FILTER]: [],
  },
  [viewTypes.PROJECT]: {
    ...sharedPreloadedFilterQueryParamsState,
    [ISSUE_FILTER_PROPERTIES.STATUS_FILTER]: [],
    [ISSUE_FILTER_PROPERTIES.COST_IMPACT]: [],
    [ISSUE_FILTER_PROPERTIES.SCHEDULE_IMPACT]: [],
    [ISSUE_FILTER_PROPERTIES.PRIORITY]: [],
    [ISSUE_FILTER_PROPERTIES.DISCIPLINE]: [],
    [ISSUE_FILTER_PROPERTIES.CATEGORY]: [],
  },
};

// Default sorting has no difference between views
export const getPreloadedSortQueryParamsState = () => {
  return {
    [SORTING_PARAMS.SORT]:'-custom_identifier',
  };
};

// define (and export) this composite preloadedState once:
export const getPreloadedQueryParamsState = () => {
  return {
    [viewTypes.DOCUMENT]: { ...preloadedFilterQueryParamsState[viewTypes.DOCUMENT], ...getPreloadedSortQueryParamsState() },
    [viewTypes.PROJECT]: { ...preloadedFilterQueryParamsState[viewTypes.PROJECT], ...getPreloadedSortQueryParamsState() },
  };
};
